import ControlViewModel from '@/ViewModels/ControlViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import DropDownTreeViewViewModel from '@/ViewModels/Controls/DropDownTreeViewViewModel';
import ComponentManager from '@/Management/ComponentManager';

/**
 * Das ViewModel für die AssociationTreeView
 */
export default class AssociationTreeViewViewModel extends ControlViewModel {

    /**
    * Der DropDownTreeView
    */
    public dropDownTreeView: DropDownTreeViewViewModel;

    /**
     * Das ViewModel für den Link zum Erzeugen eines neuen Objekts
     */
    public linkCreate: LinkViewModel;

    constructor(params: any) {
        super(params);
        this.dropDownTreeView = this.paramOrDefault(params.dropDownTreeView, null);
        this.linkCreate = this.paramOrDefault(params.linkCreate, null);
    }
}

ComponentManager.setViewModel('AssociationTreeViewViewModel', AssociationTreeViewViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');